import {
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  Button,
  Dialog,
  DialogTitle,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { numberWithCommas, removeEmptyValueObject } from '../../utils/helpers';
import useQuery from '../../utils/hook/useQuery';
import List from './components/list';
import handleError from '../../utils/handleError';
import CounterCard from '../../components/Cards/counterCard';
import { getAllTicket, getStatusCounts } from '../../api/ticket/get';
import CreateTicket from './components/registerTicket';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import type { Filter } from '../../utils/listDaynamicFilter';
import { mdiAccountOutline, mdiStateMachine, mdiCalendar, mdiHomeSearchOutline } from '@mdi/js';

const useStyles = makeStyles(theme =>
  createStyles({
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    mainContainer: {
      backgroundColor: "#fff",
      padding: "24px",
      borderRadius: "4px"
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      cursor: "pointer"
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-40px',
      display: 'flex',
      textAlign: 'center',
      paddingBottom: "12px !important"
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    icon: {
      backgroundColor: "#f5f5f5",
      padding: "10px"
    }
  })
);

const Ticketing = props => {
  const { search } = useLocation();
  const classes = useStyles();
  const filters: Filter[] = [
    {
      type: 'input',
      id: 'tracking',
      label: 'شماره تیکت',
      icon: mdiAccountOutline,
    },
    {
      type: 'checkbox',
      id: 'status.in',
      label: 'وضعیت',
      data: ['OWNER_ANSWERED', 'OPEN', 'PENDING', 'ASSIGNEE_ANSWERED', 'CLOSED'],
      translateType: 'ticket',
      icon: mdiStateMachine,
    },
    {
      type: 'checkbox',
      id: 'priority.in',
      label: 'الویت',
      data: ['LOW','NORMAL','HIGH','CRITICAL'],
      translateType: 'ticket',
      icon: mdiStateMachine,
    },
    {
      type: 'date-picker',
      id: 'createdAt.gte',
      label: 'تاریخ ایجاد',
      icon: mdiCalendar,
    },
    {
      type: 'date-picker',
      id: 'updatedAt.gte',
      label: 'تاریخ ویرایش',
      icon: mdiCalendar,
    },
    {
      type: 'input',
      id: 'subject.body',
      label: 'موضوع',
      icon: mdiHomeSearchOutline,
    },
  ]
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
    'parentId.specified': false,
    ...queryString.parse(search)
  });
  const [ticketCounts, setTicketCounts] = useState(0)
  const [openSize, setOpenSize] = React.useState(false as boolean);

  const [cardCounts, setCardCounts] = useState({});
  const [openMsg, setOpenMsg] = useState(false);
  const [loading, setLoading] = useState(true);
  const [finalizedTicketsList, setFinalTickets] = useState<any>([]);

  useEffect(() => {
    getTickets();
    getingTicketCount(request);
  }, [filtersValues]);

  const checkActiveCard = name => {
    switch (name) {
      case 'IN_SUPPORT_HAND':
        return filtersValues['advanceItem.in'] === IN_SUPPORT_HAND.join(',');
      case 'WAITING_FOR_CUSTOMER':
        return filtersValues['advanceItem.in'] === WAITING_FOR_CUSTOMER.join(',');
      case 'CLOSED':
        return filtersValues['advanceItem.in'] === CLOSED.join(',');
      case 'OPENED':
        return filtersValues['advanceItem.in'] === OPENED.join(',');
      case 'IN_FFC_TEAM':
        return filtersValues['advanceItem.in'] === IN_FFC_TEAM.join(',');
    }
  };

  const handleCardClose = () => {
    const newFilterValues = { ...filtersValues };
    delete newFilterValues['status'];
    setFiltersValues({
      ...removeEmptyValueObject(newFilterValues),
      page: 0,
      size: 10,
    });
  };

  const handleCardClick = name => {
    switch (name) {
      
      case 'IN_SUPPORT_HAND':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'advanceItem.in': IN_SUPPORT_HAND,
          page: 0,
        });
        break;
     
        case 'WAITING_FOR_CUSTOMER':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'advanceItem.in': WAITING_FOR_CUSTOMER,
          page: 0,
        });
        break;
      
        case 'CLOSED':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'advanceItem.in': CLOSED,
          page: 0,
        });
        break;
      
        case 'IN_FFC_TEAM':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'advanceItem.in': IN_FFC_TEAM,
          page: 0,
        });
        break;

        case 'OPENED':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'advanceItem.in': OPENED,
          page: 0,
        });
        break;

    }
  };

  const getTickets = async () => {
    try {
      const res = await getAllTicket(filtersValues)
      setFinalTickets(res.data.content)
      setTicketCounts(res.data.totalCount)
    } catch (error) {
      handleError(error)  
    }
  };

  const getingTicketCount = async (actions: any) => {
    try {
      setLoading(true);
      const counts = await getStatusCounts()
      setCardCounts(counts.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const request = {
    openCount: {
      'status': 'OPEN',
    },
    closeCount: {
      'status': 'CLOSED',
    },
    answeredCount: {
      'status': 'ATTENDEE_ANSWERED',
    },
    ownerAnsweredCount: {
      'status': 'OWNER_ANSWERED',
    },
  };

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleCloseModal = () => {
    setOpenMsg(false);
  };

  const IN_SUPPORT_HAND = [
    `FFC_FFC_SUPPORT_OPEN`,
    `FFC_SUPPORT_SUPPORT_OPEN`,
    `FFC_PARTNER_SUPPORT_OPEN`,
    `PARTNER_FFC_SUPPORT_OPEN`,
    `PARTNER_SUPPORT_SUPPORT_OPEN`,
    `PARTNER_PARTNER_SUPPORT_OPEN`,
    `FFC_FFC_SUPPORT_PENDING`,
    `FFC_SUPPORT_SUPPORT_PENDING`,
    `FFC_PARTNER_SUPPORT_PENDING`,
    `PARTNER_FFC_SUPPORT_PENDING`,
    `PARTNER_SUPPORT_SUPPORT_PENDING`,
    `PARTNER_PARTNER_SUPPORT_PENDING`,
    `FFC_FFC_SUPPORT_OWNER_ANSWERED`,
    `FFC_SUPPORT_SUPPORT_OWNER_ANSWERED`,
    `FFC_PARTNER_SUPPORT_OWNER_ANSWERED`,
    `PARTNER_FFC_SUPPORT_OWNER_ANSWERED`,
    `PARTNER_SUPPORT_SUPPORT_OWNER_ANSWERED`,
    `PARTNER_PARTNER_SUPPORT_OWNER_ANSWERED`,
    `SUPPORT_SUPPORT_SUPPORT_OPEN`,
    `SUPPORT_FFC_SUPPORT_OPEN`,
    `SUPPORT_PARTNER_SUPPORT_OPEN`,
    `SUPPORT_SUPPORT_SUPPORT_PENDING`,
    `SUPPORT_FFC_SUPPORT_PENDING`,
    `SUPPORT_PARTNER_SUPPORT_PENDING`,
    `SUPPORT_PARTNER_FFC_ASSIGNEE_ANSWERED`,
    `SUPPORT_SUPPORT_PARTNER_ASSIGNEE_ANSWERED`,
    `SUPPORT_SUPPORT_FFC_ASSIGNEE_ANSWERED`,
    `SUPPORT_PARTNER_PARTNER_ASSIGNEE_ANSWERED`,
    `SUPPORT_FFC_FFC_ASSIGNEE_ANSWERED`,
    `SUPPORT_FFC_PARTNER_ASSIGNEE_ANSWERED`,
    `FFC_PARTNER_PARTNER_ASSIGNEE_ANSWERED`,
    `FFC_PARTNER_FFC_ASSIGNEE_ANSWERED`,
    `SUPPORT_PARTNER_FFC_OPEN`,
    `SUPPORT_PARTNER_FFC_OWNER_ANSWERED`,
    `SUPPORT_PARTNER_PARTNER_OPEN`,
    `SUPPORT_PARTNER_PARTNER_OWNER_ANSWERED`,
    `SUPPORT_PARTNER_SUPPORT_ASSIGNEE_ANSWERED`,
    `SUPPORT_PARTNER_SUPPORT_OWNER_ANSWERED`,
    `FFC_PARTNER_PARTNER_OPEN`,
    `FFC_PARTNER_PARTNER_OWNER_ANSWERED`,
    `FFC_PARTNER_SUPPORT_ASSIGNEE_ANSWERED`,
    `FFC_PARTNER_FFC_OPEN`,
    `FFC_PARTNER_FFC_OWNER_ANSWERED`,
    'FFC_SUPPORT_PARTNER_OPEN',
    'SUPPORT_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED',
    'SUPPORT_SUPPORT_SUPPORT_OWNER_ANSWERED',
    'PARTNER_PARTNER_PARTNER_OWNER_ANSWERED',
    'PARTNER_PARTNER_FFC_OWNER_ANSWERED',
  ]
  
  const WAITING_FOR_CUSTOMER = [
    `PARTNER_FFC_FFC_ASSIGNEE_ANSWERED`,
    `PARTNER_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED`,
    `PARTNER_FFC_SUPPORT_ASSIGNEE_ANSWERED`,
    `PARTNER_SUPPORT_FFC_ASSIGNEE_ANSWERED`,
    `FFC_FFC_PARTNER_OWNER_ANSWERED`,
    `FFC_SUPPORT_PARTNER_OWNER_ANSWERED`,
    `SUPPORT_FFC_PARTNER_OWNER_ANSWERED`,
    `SUPPORT_SUPPORT_PARTNER_OWNER_ANSWERED`,
    `PARTNER_PARTNER_PARTNER_PENDING`,
    `PARTNER_FFC_PARTNER_PENDING`,
    `PARTNER_SUPPORT_PARTNER_PENDING`,
    `SUPPORT_PARTNER_PARTNER_PENDING`,
    `SUPPORT_FFC_PARTNER_PENDING`,
    `SUPPORT_SUPPORT_PARTNER_PENDING`,
    `FFC_PARTNER_PARTNER_PENDING`,
    `FFC_FFC_PARTNER_PENDING`,
    `FFC_SUPPORT_PARTNER_PENDING`,
    `PARTNER_SUPPORT_PARTNER_ASSIGNEE_ANSWERED`,
  ]
     
  const IN_FFC_TEAM = [
    "FFC_FFC_FFC_PENDING",
    "FFC_SUPPORT_FFC_PENDING",
    "FFC_PARTNER_FFC_PENDING",
    "SUPPORT_PARTNER_FFC_PENDING",
    "SUPPORT_SUPPORT_FFC_PENDING",
    "SUPPORT_FFC_FFC_PENDING",
    "PARTNER_SUPPORT_FFC_PENDING",
    "PARTNER_PARTNER_FFC_PENDING",
    "PARTNER_FFC_FFC_PENDING",     
    "FFC_SUPPORT_SUPPORT_ASSIGNEE_ANSWERED",
    "FFC_SUPPORT_FFC_ASSIGNEE_ANSWERED",
    "SUPPORT_SUPPORT_FFC_OWNER_ANSWERED",
    "PARTNER_SUPPORT_FFC_OWNER_ANSWERED",
  ]

  const CLOSED = [
    `PARTNER_PARTNER_PARTNER_CLOSED`,
    `PARTNER_PARTNER_SUPPORT_CLOSED`,
    `PARTNER_PARTNER_FFC_CLOSED`,
    `PARTNER_SUPPORT_PARTNER_CLOSED`,
    `PARTNER_SUPPORT_SUPPORT_CLOSED`,
    `PARTNER_SUPPORT_FFC_CLOSED`,
    `PARTNER_FFC_PARTNER_CLOSED`,
    `PARTNER_FFC_SUPPORT_CLOSED`,
    `PARTNER_FFC_FFC_CLOSED`,
    `SUPPORT_PARTNER_PARTNER_CLOSED`,
    `SUPPORT_PARTNER_SUPPORT_CLOSED`,
    `SUPPORT_PARTNER_FFC_CLOSED`,
    `SUPPORT_SUPPORT_PARTNER_CLOSED`,
    `SUPPORT_SUPPORT_SUPPORT_CLOSED`,
    `SUPPORT_SUPPORT_FFC_CLOSED`,
    `SUPPORT_FFC_PARTNER_CLOSED`,
    `SUPPORT_FFC_SUPPORT_CLOSED`,
    `SUPPORT_FFC_FFC_CLOSED`,
    `FFC_PARTNER_PARTNER_CLOSED`,
    `FFC_PARTNER_SUPPORT_CLOSED`,
    `FFC_PARTNER_FFC_CLOSED`,
    `FFC_SUPPORT_PARTNER_CLOSED`,
    `FFC_SUPPORT_SUPPORT_CLOSED`,
    `FFC_SUPPORT_FFC_CLOSED`,
    `FFC_FFC_PARTNER_CLOSED`,
    `FFC_FFC_SUPPORT_CLOSED`,
    `FFC_FFC_FFC_CLOSED`,
  ]

  const OPENED = [
    "SUPPORT_SUPPORT_SUPPORT_OPEN",
    "SUPPORT_SUPPORT_PARTNER_OPEN",
    "SUPPORT_SUPPORT_FFC_OPEN",  
  ]  

  const calculatSum = (data: any, statuses: string[]) => {
    let total_sum = 0;
    if (statuses !== undefined) {
      statuses.forEach(status => {
        console.log('data[', status,'] : ', data[status])
        total_sum +=  (data[status]) ?? 0
      });
    }
    return total_sum;
  }

  const CustomizedCounterCard = ({data, status, cardCountStatus, title}) => {
    return (
      <Grid item md={6} lg xs={6}>
        <CounterCard
          isActive={checkActiveCard(status)}
          data={numberWithCommas(calculatSum(data, cardCountStatus) || 0)}
          handleClick={() => handleCardClick(status)}
          label={title}
          icon="mailUnread"
          iconColor="#2f4858"
          color="#f5f5f5"
          dActiveCard={handleCardClose}
        />
      </Grid> 
    )
  }

  return (
    <React.Fragment>
      <Grid container item xs={12} sm={6} alignItems="center">
        <Typography variant="h6" component="div">
          پشتیبانی
        </Typography>
      </Grid>
      <Grid container justifyContent='flex-end' style={{marginBottom: '16px'}}>
        <Grid item xs={12} sm={6}>
            <RenderFilter
              filters={filters}
              onFilter={(filtervalues: any) => {
                setFiltersValues({
                  ...removeEmptyValueObject(filtervalues),
                  page: 0,
                  size: 100,
                });
              }}
              mainFiltersCount={0}
              baseFilter={{
                type: 'input',
                id: 'tracking',
                placeholder: 'شناسه تیکت',
              }}
              filterValues={filtersValues}
            />
        </Grid>
      </Grid>
      <div className={classes.mainContainer}>
        <Grid container spacing={2} style={{marginBottom: "24px"}}>
          <CustomizedCounterCard data={cardCounts} title='نیاز به بررسی' status='IN_FFC_TEAM' cardCountStatus={IN_FFC_TEAM} />
          <CustomizedCounterCard data={cardCounts} title='نیاز به بررسی پشتیبانی' status='IN_SUPPORT_HAND' cardCountStatus={IN_SUPPORT_HAND} />
          <CustomizedCounterCard data={cardCounts} title='منتظر پاسخ مشتری' status='WAITING_FOR_CUSTOMER' cardCountStatus={WAITING_FOR_CUSTOMER} />
          <CustomizedCounterCard data={cardCounts} title='ایجاد شده' status='OPENED' cardCountStatus={OPENED} />
          <CustomizedCounterCard data={cardCounts} title='بسته شده' status='CLOSED' cardCountStatus={CLOSED} />
        </Grid>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{marginBottom: "24px"}}
          >
            {/* <Grid item>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => setOpenMsg(true)}
              >
                {`تیکت جدید`}
              </Button>
            </Grid> */}
          </Grid>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {finalizedTicketsList?.length > 0 ? (
                <List
                  data={
                    finalizedTicketsList
                  }
                />
              ) : (
                <Typography variant="h3" component="div">
                  تیکت موجود نیست
                </Typography>
              )}
            </>
          )}
          <Grid item xs={12} sm={12} style={{ marginTop: '24px' }}>
            {finalizedTicketsList?.length > 0 && (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <FormControl
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                    {' '}
                    تعداد نمایش در هر صفحه:
                  </div>
                  <Select
                    open={openSize}
                    onClose={handleClose}
                    onOpen={() => setOpenSize(true)}
                    value={filtersValues.size}
                    onChange={handleChangeSizePage}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Pagination
                  count={Math.ceil(
                    ticketCounts / filtersValues.size
                  )}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              </div>
            )}
          </Grid>
      </div>
      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{ padding: '16px' }}
      >
        <DialogTitle>
          <Grid container justifyContent="center" justify="center">
            <p style={{ marginTop: '-8px' }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction="column">
          <CreateTicket handleCloseModal={handleCloseModal} getTickets={getTickets}/>
        </Grid>
      </Dialog>
    </React.Fragment>
  );
};

export default Ticketing;
